import {SortState} from "./enums/sort-state.enum";

export class HeaderSort {
    sortBy: string | null;
    sortAscending: boolean;
    secondarySortBy: string | null;
    secondarySortAscending: boolean;
    initialState: SortState;

    constructor(
        sortBy: string | null,
        sortAscending: boolean,
        secondarySortBy?: string | null,
        secondarySortAscending?: boolean | null,
        initialState?: SortState | null
    ) {
        this.sortBy = sortBy;
        this.sortAscending = sortAscending;
        this.secondarySortBy = secondarySortBy;
        this.secondarySortAscending = secondarySortAscending;
        this.initialState = initialState;
    }
}
